import { Skeleton } from '@/components/ui/Skeleton.tsx';
import {
  InfoCard,
  InfoCardBody,
  InfoCardHeader,
  InfoCardRow,
} from '@/components/ui/InfoCard.tsx';

/** Szkielet karty „Stan rezerwacji”: nagłówek, link, data i cztery wiersze. */
const BookingStateCardSkeleton = (
  props: React.HTMLAttributes<HTMLDivElement>,
) => (
  <InfoCard {...props}>
    <InfoCardHeader title={<Skeleton className="h-3.5 w-32" />}>
      <div className="mt-[7px] flex items-center gap-2">
        <Skeleton className="h-4 w-28" />
        <Skeleton className="h-3.5 w-36" />
      </div>
      <Skeleton className="mt-1.5 h-3.5 w-40" />
    </InfoCardHeader>

    <InfoCardBody>
      {['wartosc', 'wplacono', 'do-zaplaty'].map((row) => (
        <InfoCardRow key={row} label={<Skeleton className="h-4 w-20" />}>
          <Skeleton className="h-4 w-24" />
        </InfoCardRow>
      ))}
      <InfoCardRow divided label={<Skeleton className="h-4 w-14" />}>
        <Skeleton className="h-[26px] w-24 rounded-md" />
      </InfoCardRow>
    </InfoCardBody>
  </InfoCard>
);

export default BookingStateCardSkeleton;
